import React from 'react';
import { Field,  reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { Input, Select } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const RefundUnbookedAnnual = ({ error, handleSubmit, pristine, submitSucceeded, cancellationReasonType, cancellationReasonTypes, onReasonChange, initialValues, t }) => {
	let isOtherReason = cancellationReasonType == 99;
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Select name='cancellationReasonType' data={cancellationReasonTypes} horizontal required label={t('ChildLesson_CancellationReason')} validate={validators.required} onChange={onReasonChange}/>
			{isOtherReason && <Field name='otherCancellationReason' component={Input} horizontal componentClass='textarea' label={t('ChildLesson_OtherCancellationReason')}/>}
		</Form>
	);
};

export default reduxForm({ form: 'refundUnbookedAnnual' })(withTranslation()(RefundUnbookedAnnual));